module.exports = __webpack_public_path__ + "img/4.97d29a5b.svg";